export class OurCustomersSectionComponent {

  _sliderContainerEl;

  init() {
    this._sliderContainerEl = document.querySelector('.our-customers-section .customers__inner');

    if (this._sliderContainerEl) {
      this.sliderInit();

    }
  }

  sliderInit() {
      const prevBtn = this._sliderContainerEl.querySelector('#customer-reviews-prev-btn');
      const nextBtn = this._sliderContainerEl.querySelector('#customer-reviews-next-btn');
      const logos = Array.from(document.querySelectorAll('.customers__inner__customer'));
      let numberToBeDisplayed;

      (onWindowResize.bind(this))();

      logos.forEach((logo, idx) => {
        if ( idx >= numberToBeDisplayed ) {
          logo.classList.add('d-none');
        }
      });

      prevBtn.addEventListener('click', onPrevBtnClick);
      nextBtn.addEventListener('click', onNextBtnClick);
      window.addEventListener('resize', onWindowResize.bind(this));

      function onPrevBtnClick() {
        logos.unshift(...logos.splice(-numberToBeDisplayed));

        shuffleLogos();
      }

      function onNextBtnClick() {
        logos.push(...logos.splice(0, numberToBeDisplayed));

        shuffleLogos();
      }

      function shuffleLogos() {
        logos.forEach((logo, idx) => {
          logo.classList.add('d-none');

          if ( idx < numberToBeDisplayed ) {
            logo.classList.remove('d-none');
          }
        });
      }

      function onWindowResize () {
          const containerWidth = parseInt(getComputedStyle(this._sliderContainerEl).getPropertyValue('width'));
          const numberOfCols = Math.trunc(containerWidth / (logos[0].getBoundingClientRect().width + 2 *
            parseInt(window.getComputedStyle(logos[0]).getPropertyValue('margin-left')))
          );

          numberToBeDisplayed = 2 * numberOfCols - 1;
          shuffleLogos();
      }
  }
}
